<template>
  <div class="column" style="margin-inline-end: 2px;">
    <div  class="card dash-card headercard" 
          style="margin-top:2px;"
          :style="{ 'height': getCtBorderHeight() }">
      <div class="card-header dash-card-header">
        <div :style="{ 'height': getCtHeight() }"></div>
      </div>

      <!-- Cluster 9 -->
      <div class="card-body dash-card-body">
        <tableitem :overallByWave="getOverallByWave"
                   :kpi="getKpiCustomerTreatment"
                   :hideNSC="true"
                   :isExtraNarrow="true"
                   :isHeader="true" />
        <titleunderline :hasKpi="getKpiCustomerTreatment !== undefined" />
      </div>
    </div>

    <RecommendationTable  :recommend="getOverallRecommendation()"
                          :title="getTextRecommend()"
                          :hasAsterisk="false"
                          :proHeader="getText('Promoters')"
                          :contraHeader="getText('Detractors')"
                          :neutralHeader="getText('Passives')"
                          :showNPS="true"
                          style="height: 140px;" />

    <!-- Shops Count Stats -->
    <div class="card dash-card" id="shops">
      <div class="card-header dash-card-header" style="height: 30px; background: transparent; ">
        <p class="text-center text-bold" style="font-size: 14px"><strong>{{$t('Webportal.Dashboard.NumberOfShops')}} <span class="smalltext">({{$t('Webportal.Dashboard.Total')}} {{ getShops }})</span></strong></p>
      </div>
      <div class="card-body dash-card-body">
        <ShopsOverall style="width: 100%; height:80px;"
                      :overallValues="getOverallByWave"
                      :isCompetitionOverall="false"
                      />
      </div>
    </div>

    <!-- Legende -->
    <LegendControl :showTextItems="false" />

  </div>

</template>


<script>

  import performanceitem from '@/components/Dashboard-lambo/PerformanceItem'
  import tableitem from '@/components/Dashboard-lambo/TableItem.vue'
  import ShopsOverall from '@/components/Dashboard-lambo/ShopsOverall'
  import LegendControl from './LegendControl'
  import titleunderline from '@/components/Dashboard-lambo/TitleUnderline'
  import RecommendationTable from "./RecommendationTable"
  import KpiMixin from '@/mixins/lambo/KpiMixin';

  export default {
    name: 'LamboCustomerTreatmentColumn',

    props: {
      survey: { type: Number, default: 0 }
    },

    components: {
      performanceitem,
      tableitem,
      ShopsOverall,
      LegendControl,
      titleunderline,
      RecommendationTable
    },

    mixins: [ KpiMixin ],

    methods:{
      getCtHeight() {
        if (this.survey >= 1086 && this.survey <= 1090) {
          if (this.getKpiCustomerTreatmentName !== '-') {
            return '90px !important';
          } else {
            return '90px !important';
          }
        } else {
          if (this.getKpiCustomerTreatmentName !== '-') {
            return '40px !important';
          } else {
            return '40px !important';
          }
        }
      },
      getCtBorderHeight() {
        if (this.survey >= 1086 && this.survey <= 1090) {
          return '192px';
        } else {
          return '144px';
        }
      },

      getText(key) {
        return this.$t('Webportal.Dashboard.' + key);
      },

      getTextRecommend() {
        return this.$t('Webportal.Dashboard.NetPromoterScore');
      },

      getOverallRecommendation() {
        if (this.dashdata && this.dashdata.Recommendation && _.size(this.dashdata.Recommendation) > 0)
          return this.dashdata.Recommendation[0]
      }
    },

    computed: {
      getKpiCustomerTreatmentName: function() {
        const item = this.getKpiCustomerTreatment;
        if (item) { return item.KpiName }
        return '-'
      },

      getKpiCustomerTreatment: function() {
        return this.getKpiByString('05. Customer Treatment') 
            ?? this.getKpiByString('08. Customer Treatment');
      },

      getShops: function () {
        const item = this.getOverallItem()
        if (!item) { return '-' }
        return item.NumberOfShopsTotal
      }
    }
  }

</script>